import Box from '@/components/base/box.component';
import CardContent from '@/components/base/card/card-content.component';
import CardHeader from '@/components/base/card/card-header.component';
import Card from '@/components/base/card/card.component';
import { CircularLoaderContainer } from '@/components/base/circular-loader-container.component';
import { useGlobalStore } from '@/stores';
import { formatAddressNewLine } from '@/utils/format-address-new-line';
import { Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  useDefaultBillingAddress,
  useGetAddressesByBusinessPartnerId,
} from '@/api/business-partner/business-partner.hooks.ts';
import { useTranslation } from 'react-i18next';

export function CartDeliveryAddressCard() {
  const navigate = useNavigate();
  const { t } = useTranslation('cart');
  const addresses = useGetAddressesByBusinessPartnerId();
  const store = useGlobalStore();

  const { defaultBillingAddress, isPending: isDefaultBillingAddressPending } =
    useDefaultBillingAddress();
  const { addressName2, addressName3, street, zipCode, city, country } = store;
  const cartAddress = {
    addressName2,
    addressName3,
    street,
    zipCode,
    city,
    country,
  };

  return (
    <Card
      sx={{
        width: '100%',
      }}
      elevation={2}
    >
      <CardHeader title={t('confirm.addresses')} />
      {isDefaultBillingAddressPending ? (
        <CircularLoaderContainer />
      ) : (
        <CardContent sx={{ width: '100%' }}>
          <Stack
            sx={{
              width: '100%',
              justifyContent: 'space-between',
            }}
            direction={'row'}
            spacing={4}
          >
            <Box
              sx={{
                width: '100%',
              }}
            >
              <Typography variant={'subtitle2'}>
                {t('confirm.billingAddress')}
              </Typography>
              <Typography
                sx={{
                  whiteSpace: 'pre-wrap',
                }}
              >
                {defaultBillingAddress
                  ? formatAddressNewLine(defaultBillingAddress)
                  : t('confirm.addressError')}
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
              }}
            >
              <Typography variant={'subtitle2'}>
                {t('confirm.shippingAddress')}
              </Typography>
              <Typography
                sx={{
                  whiteSpace: 'pre-wrap',
                }}
              >
                {cartAddress
                  ? formatAddressNewLine(cartAddress)
                  : t('confirm.addressError')}
              </Typography>
            </Box>
          </Stack>
        </CardContent>
      )}
    </Card>
  );
}
